<template>
    <client-only>
        <div class="desktop-translate-rights"  :class="[ bizTeamInfo?.serviceLevel ? 'translateRights' + bizTeamInfo?.serviceLevel : '', {}]">
            <div class="rights-top">
                <div class="rights-top-title" v-if="bizTeamInfo?.serviceLevel >= 0">
                    {{ currentBusinessPlanTitle }}
                </div>
                <div class="rights-top-content" v-if="!bizTeamInfo || Object.keys(bizTeamInfo).length === 0">
                    <div class="rights-top-content-title">
                        {{ t('account_rights_gear1_subTitle') }}
                    </div>
                    <div class="rights-upBtn" @click="handleBuy(0)">
                        <div class="rights-top-content-subTitle">
                            {{ t('account_rights_gear1_btn') }}
                        </div>
                        <i class="iconfont icon-icon_arrowsrigh"></i>
                    </div>
                </div>
                <div class="rights-top-content" v-if="bizTeamInfo?.serviceLevel === 0">
                    <div class="rights-top-content-title">
                        {{ t('account_rights_gear1_subTitle') }}
                    </div>
                    <div class="rights-upBtn" @click="handleBuy(0)">
                        <div class="rights-top-content-subTitle">
                            {{ t('account_rights_gear1_btn') }}
                        </div>
                        <i class="iconfont icon-icon_arrowsrigh"></i>
                    </div>
                </div>
                <div class="rights-top-content" v-if="bizTeamInfo?.serviceLevel > 0">
                    <div class="rights-top-content-title">
                        {{ t('account_rights_gear_time_end_title').replace('*', currentVipEndTime)}}
                    </div>
                    <!-- <div class="rights-upBtn">
                        <div class="rights-top-content-subTitle">
                            {{ t('account_rights_gear_time_end_renew') }}
                        </div>
                        <i class="iconfont icon-icon_arrowsrigh"></i>
                    </div> -->
                </div>
            </div>
            <div class="rights-bottom">
                <div class="rights-bottom-title">
                    {{ t('account_rights_char_num_title').replace('*', currentBusinessCharNum) }}
                </div>
                <div class="rights-bottom-btn" @click="handleRenewClick">
                    <div class="rights-bottom-btn-title">
                        {{ t('account_rights_char_num_btn') }}
                    </div>
                    <i class="iconfont icon-icon_arrowsrigh"></i>
                </div>
            </div>
        </div>
    </client-only>
</template>

<script setup lang="ts">
import { IVipLevel } from '~/services/UserServer/types';
import useUserStore from '~/store/modules/user';
import useBasicStore from '~/store/modules/basic';
import { getProBusinessSubscribeConfig } from "@/config/proConfig"
import type ProDialog from '~/components/Pro/ProDialog/ProDialog.vue'
import { ActiveType, TimeType } from '~/types/const';
import type SubscribeDialog from '~/components/SubscribeDialog/index.vue'
const userStore = useUserStore()
const { userInfo, userRights, userRemark, bizTeamInfo } = storeToRefs(userStore)
const { isChina } = storeToRefs(useBasicStore())
const router = useRouter()
const route = useRoute()
const attrs = useAttrs()
const { t, te, locale } = useI18n()
let freeIcon: string;
onMounted(()=>{
    freeIcon = new URL('@/assets/images/vip/icon_free@2x.png', import.meta.url).href
})
const subscribeDialogRef = inject('subscribeDialogRef') as Ref<InstanceType<typeof SubscribeDialog>>
    
const currentVipEndTime = computed(()=>{
  const vipIntevalEndTime = bizTeamInfo.value && bizTeamInfo.value.serviceEndTime
//   console.log('asdadadad==>>',formatDate(vipIntevalEndTime, "YY-MM-DD"))
  if (vipIntevalEndTime) return `${formatDate(vipIntevalEndTime, "YY-MM-DD")}`
  return ''
})

const currentBusinessPlanTitle = computed(() => {
    const key = `account_rights_gear_title_${Number(bizTeamInfo.value?.serviceLevel || 0)}`
    return te(key) ? t(key) : t('business_title')
})

const currentBusinessCharNum = computed(()=>{
    let charNum = bizTeamInfo.value?.remainServiceWords || 0
    if (bizTeamInfo.value?.remainPackageWords) {
        charNum = charNum + bizTeamInfo.value?.remainPackageWords
    }
    return charNum.toLocaleString()
})

const handleSubscribeClick = () => {
    subscribeDialogRef.value?.open()
}

const proDialogRef = inject('proDialogRef') as Ref<InstanceType<typeof ProDialog>>

function handleBuy(type: number) {
  let coinKey = userStore.getCurrentCoin(locale.value)
  const items = getProBusinessSubscribeConfig(coinKey)
  proDialogRef.value?.open({...items[type], mode: 0})
}

const handleRenewClick = () => {
    if (route.query.menu == 'combo') {
        return
    }
    router.push({path: '/account', query: {menu: 'combo'}})
}
</script>

<style lang="scss" scoped>
@use './index.scss' as *;
</style>
